<template>
  <div id="app">
    <StudentChatGraph />
  </div>
</template>

<script>
import StudentChatGraph from "./components/StudentChatGraph.vue";

export default {
  name: "app",
  components: {
    StudentChatGraph
  }
};
</script>